import React from 'react';
import classes from "./Loading.module.scss";
import PropTypes from "prop-types";

export const Loading = ({dark}) => {
    return (
        <div data-testid={'loading'} className={`${classes['loading']} ${dark ? classes['loading-dark'] : ''}`}/>
    );
};

Loading.propTypes = {
    /**
     * set true to have the primary variant
     */
    dark: PropTypes.bool
}

Loading.defaultProps = {
    dark: undefined
}